/* Auth module */
export const RESET_AUTH = 'resetAuth';
export const PURGE_AUTH = 'purgeAuth';
export const SET_TOKEN = 'setToken';
export const UPDATE_SHIFT = 'updateShift';
export const START_DAY = 'startDay';

/* Currency module */
export const RESET_ALL_CURRENCIES = 'resetAllCurrencies';

/* Shift module */
export const SET_SHIFT_CURRENT_ACTION = 'setShiftCurrentAction';

/* Shift module */
export const SET_DAY_CURRENT_ACTION = 'setDayCurrentAction';

/* Toggle module */
export const RESET_ALL_TOGGLE = 'resetAllToggle';
export const SET_MESSAGE_MODAL = 'setMessageModal';
export const SET_CONFIRM_MODAL = 'setConfirmModal';
export const TOGGLE_BILL_MODAL_VISIBLE = 'toggleBillModalVisible';
export const TOGGLE_CREDIT_BACK_BUTTON = 'toggleCreditBackButton';
export const TOGGLE_ORDER_LEVEL_BUTTON = 'toggleOrderLevelButton';
export const TOGGLE_MIXER_MODAL = 'toggleMixerModal';
export const TOGGLE_MENU_SIDE = 'toggleMenuSide';
export const SET_ACTIVE_ELEMENT = 'setActiveElement';
export const START_LOADING = 'startLoading';
export const END_LOADING = 'endLoading';

/* Input Pad module */
export const SET_CURRENT_INPUT_PAD = 'setCurrentInputPad';
export const ON_INPUT_PAD_BLUR = 'onInputPadBlur';
export const SET_INPUT_PAD_LENGTH = 'setInputPadLength';
